module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Proof of work equivalent days to rewrite the complete BTC or BCH chain with 100% of available hashrate. Basically the same idea as the \"fork rewrite\" chart only for the entire blockchain.\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-attack-full"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e01c16","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/rewrite-chain.vue
// module id = 542
// module chunks = 1